import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { ListType } from '../types';

export class GtmStatsAdapterList implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): ListType {
    // Sign in click context from lead form
    if (
      this.context.local.cta &&
      (this.context.local.cta.authentication === 'login-popup-from-lead' ||
        this.context.local.cta.authentication === 'login-popup-not-now-button' ||
        this.context.local.cta.authentication === 'login-popup-close-button')
    ) {
      return 'Post Email Lead';
    }

    // Sign in click context from lead form
    if (this.context.local.cta && this.context.local.cta.authentication === 'login-popup-tooltip') {
      return 'Save Property Pop up';
    }

    // User box "contacted" context
    if (this.context.global.saved_properties) {
      return 'Saved Properties';
    }

    // User box "my notes" context
    if (this.context.global.my_notes_properties) {
      return 'My Notes Properties';
    }

    // User box "notes" context
    if (
      this.context.local.cta &&
      this.context.local.cta.notes &&
      this.context.local.cta.notes.name === 'login-property-note'
    ) {
      return 'Save My Notes';
    }

    // User box "saved" context
    if (this.context.global.contacted_properties) {
      return 'Contacted Properties';
    }

    // Property "more available" context
    if (this.context.local.property_more) {
      return 'More Available';
    }

    // Property "similar available" context
    if (this.context.local.property_similar) {
      return 'Property Serp No Result';
    }

    // Custom event label
    if (this.context.local.cta) {
      if (this.context.local.cta.event) {
        return this.context.local.cta.event.label;
      }
    }

    if (this.context.global.property_page) {
      return 'Property Detail';
    }

    if (this.context.global.property_page_with_community_expert) {
      return 'Property Detail - Community Expert';
    }

    if (this.context.global.property_page_offline) {
      return 'Expired Property';
    }

    if (this.context.global.map_search_page) {
      return 'Map Search';
    }

    if (this.context.global.property_serp) {
      return 'Property Serp';
    }

    if (this.context.global.agent_home) {
      return 'Agent Home';
    }

    if (this.context.global.agent_page) {
      return 'Agent Detail';
    }

    if (this.context.global.agent_serp) {
      return 'Agent Serp';
    }

    if (this.context.global.broker_home) {
      return 'Broker Home';
    }

    if (this.context.global.broker_page) {
      return 'Broker Detail';
    }

    if (this.context.global.broker_serp) {
      return 'Broker Serp';
    }

    if (this.context.global.home_page) {
      return 'Portal Home';
    }

    if (this.context.global.user_page) {
      return 'Saved Properties';
    }

    if (this.context.global.error_page) {
      return 'Not Found';
    }

    if (this.context.global.buyvsrent_calculator) {
      return 'Buy Vs Rent Calculator';
    }

    if (this.context.global.home_valuation) {
      return 'Home Valuation';
    }

    return 'Static';
  }
}
